import React, { createContext, useState, useContext, useEffect } from 'react';
import { saveImageToDB, getAllImagesFromDB } from '../utils/imageStorage';

const DataContext = createContext();

// Default data
const defaultData = {
  heroSlides: [
    { id: 1, gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', image: '' },
    { id: 2, gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', image: '' },
    { id: 3, gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)', image: '' },
    { id: 4, gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)', image: '' },
    { id: 5, gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)', image: '' },
  ],
  carouselImages: [
    { id: 1, title: 'Church Community Image 1', image: '' },
    { id: 2, title: 'Church Community Image 2', image: '' },
    { id: 3, title: 'Church Community Image 3', image: '' },
    { id: 4, title: 'Church Community Image 4', image: '' },
  ],
  churchInfo: {
    name: 'House Of Worship Bangkal',
    tagline: 'Where would we be if not for "God\'s Grace"',
    description: 'This is our living testimony! Our desire is to help you discover Jesus, His promises and Glorious plan in your life.',
    address: 'House of Worship (HOW), Bangkal, Davao City, Philippines',
    phone: '+63 XXX XXX XXXX',
    email: 'info@houseofworshipbangkal.com',
    mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d989.8909901885514!2d125.55401911959839!3d7.060409100000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x32f90d0046b2a34d%3A0xd513d93b104d9c75!2sHouse%20of%20Worship%20(HOW)!5e0!3m2!1sen!2sph!4v1735100000000!5m2!1sen!2sph'
  },
  socialLinks: {
    youtube: 'https://youtube.com/@YourChannelHere',
    facebook: 'https://facebook.com',
    instagram: 'https://instagram.com'
  },
  videos: [
    { id: 1, title: 'Sunday Worship Service', description: 'Join us for our weekly Sunday worship service filled with praise and the Word of God.', youtubeId: '' },
    { id: 2, title: 'Bible Study Session', description: 'Dive deep into God\'s Word with our interactive Bible study sessions.', youtubeId: '' },
    { id: 3, title: 'Youth Fellowship', description: 'Watch highlights from our vibrant youth fellowship gatherings.', youtubeId: '' },
    { id: 4, title: 'Praise & Worship Night', description: 'Experience the power of worship through our special praise nights.', youtubeId: '' },
    { id: 5, title: 'Community Outreach', description: 'See how we serve our community through various outreach programs.', youtubeId: '' },
    { id: 6, title: 'Testimonies', description: 'Hear powerful testimonies of lives transformed by God\'s grace.', youtubeId: '' }
  ],
  events: [
    { id: 1, title: 'Sunday Worship Service', date: 'Every Sunday', time: '9:00 AM - 12:00 PM', location: 'Main Sanctuary', description: 'Join us for a powerful time of worship, praise, and the Word of God.', icon: 'pray', gradient: 'linear-gradient(135deg, #7c4dff 0%, #b388ff 100%)' },
    { id: 2, title: 'Midweek Bible Study', date: 'Every Wednesday', time: '7:00 PM - 9:00 PM', location: 'Fellowship Hall', description: 'Dive deeper into Scripture and grow in your faith with fellow believers.', icon: 'book', gradient: 'linear-gradient(135deg, #536dfe 0%, #8c9eff 100%)' },
    { id: 3, title: 'Youth Night', date: 'Every Friday', time: '6:00 PM - 9:00 PM', location: 'Youth Center', description: 'A fun and impactful night for young people to connect and grow.', icon: 'users', gradient: 'linear-gradient(135deg, #ce93d8 0%, #f48fb1 100%)' },
    { id: 4, title: 'Worship Night', date: 'First Saturday of Month', time: '6:00 PM - 8:00 PM', location: 'Main Sanctuary', description: 'An evening dedicated to extended worship and prayer.', icon: 'music', gradient: 'linear-gradient(135deg, #90caf9 0%, #80deea 100%)' },
    { id: 5, title: 'Community Outreach', date: 'Last Saturday of Month', time: '8:00 AM - 12:00 PM', location: 'Various Locations', description: 'Serve our community and share God\'s love through practical acts of kindness.', icon: 'heart', gradient: 'linear-gradient(135deg, #f48fb1 0%, #ff80ab 100%)' }
  ],
  weeklySchedule: [
    { id: 1, day: 'Sunday', time: '9:00 AM', service: 'Main Worship Service', icon: 'pray' },
    { id: 2, day: 'Tuesday', time: '7:00 PM', service: 'Prayer Meeting', icon: 'pray' },
    { id: 3, day: 'Wednesday', time: '7:00 PM', service: 'Bible Study', icon: 'book' },
    { id: 4, day: 'Friday', time: '6:00 PM', service: 'Youth Night', icon: 'users' }
  ],
  aboutContent: {
    story: [
      'House Of Worship Davao was founded with a simple yet profound mission: to create a place where everyone can experience God\'s love and grace. From humble beginnings, we have grown into a thriving community of believers who are passionate about worship, discipleship, and service.',
      '"Where would we be if not for God\'s Grace" - This is our living testimony! Every day, we witness the transformative power of God in the lives of our members and the community we serve. Our desire is to help you discover Jesus, His promises, and His glorious plan for your life.'
    ],
    values: [
      { icon: 'pray', title: 'Faith', text: 'We believe in the power of faith and trust in God\'s plan for our lives.' },
      { icon: 'heart', title: 'Love', text: 'Love is at the center of everything we do, reflecting Christ\'s love to all.' },
      { icon: 'users', title: 'Community', text: 'We are stronger together, building meaningful relationships in Christ.' },
      { icon: 'hands', title: 'Service', text: 'Serving others is our calling, making a difference in our community.' },
      { icon: 'star', title: 'Excellence', text: 'We strive for excellence in worship, ministry, and all we do.' },
      { icon: 'church', title: 'Worship', text: 'Passionate worship that honors God and transforms lives.' }
    ],
    team: [
      // Top Level - Senior Pastors (Side by Side)
      { id: 1, name: 'Ptr. Jerry S. Bariquatro Sr.', role: 'Senior Pastor / HOW Mindanao', initials: 'JS', image: '/leaders/JERRY SR.png', level: 1, order: 1, position: 'left' },
      { id: 2, name: 'Ptr. Analiza R. Bariquatro', role: 'Overseer Pastor / Missionary', initials: 'AR', image: '/leaders/ANALIZA.png', level: 1, order: 2, position: 'right' },
      
      // Level 2 - Host Pastor
      { id: 3, name: 'Ptr. Jerry R. Bariquatro Jr.', role: 'Host Pastor / HOW Bangkal', initials: 'JJ', image: '/leaders/JERRY JR.png', level: 2, order: 1 },
      
      // Level 3 - Assistant Host Pastor
      { id: 4, name: 'Ptr. Erwin Toblazo', role: 'Assistant Host Pastor / Worship', initials: 'ET', image: '/leaders/ERWIN.png', level: 3, order: 1 },
      
      // Church Admin (Center Branch)
      { id: 5, name: 'Sis. Cristy D. Bariquatro', role: 'Church Administrator', initials: 'CB', image: '/leaders/CRISTY.png', level: 4, order: 1, department: 'admin' },
      
      // Facilities Manager (Right Branch)
      { id: 6, name: 'Bro. Jhonrey B. Bariquatro', role: 'Facilities Manager', initials: 'JB', image: '/leaders/JHONREY.png', level: 4, order: 2, department: 'facilities' },
      { id: 7, name: 'Missionary Arnold Supe', role: 'Assistant Facilities Manager', initials: 'AS', image: '/leaders/ARNOLD.png', level: 5, order: 1, department: 'facilities' },
      
      // Accounting and Finance Department
      { id: 8, name: 'Ptr. Jonamae L. Bariquatro', role: 'Treasurer', initials: 'JL', image: '/leaders/JONAMAE.png', level: 5, order: 1, department: 'accounting' },
      { id: 9, name: 'Sis. Girly Ferenal', role: 'Assistant Treasurer', initials: 'GP', image: '/leaders/GIRLY.png', level: 5, order: 2, department: 'accounting' },
      { id: 10, name: 'Sis. Jhovy Sia', role: 'Auditor', initials: 'JS', image: '/leaders/JHOVY.png', level: 5, order: 3, department: 'accounting' },
      
      // Multimedia Department
      { id: 12, name: 'Ptr. Ramon Muniz', role: 'Technical Head - Multimedia', initials: 'RM', image: '/leaders/RAMON.png', level: 5, order: 1, department: 'multimedia' },
      { id: 13, name: 'Bro. Christian O. Halasan', role: 'Head PTL / Media Staff', initials: 'CH', image: '/leaders/CHRISTIAN.jpg', level: 5, order: 2, department: 'multimedia' },
      { id: 14, name: 'Bro. Reneboy Nunez', role: 'Asst Head / Editor / Social', initials: 'RN', image: '/leaders/RENEBOY.jpg', level: 5, order: 3, department: 'multimedia' },
      
      // Ministry Leaders - Men's Ministry
      { id: 15, name: 'Ptr. Ruther Maymaran', role: 'Mens Ministry Leader', initials: 'RM', image: '/leaders/RUTHER.png', level: 6, order: 1, ministry: 'men' },
      { id: 16, name: 'Ptr. Erwin Tonacao', role: 'Mens Ministry', initials: 'ET', image: '/leaders/ERWIN.png', level: 6, order: 2, ministry: 'men' },
      
      // Women's Ministry
      { id: 17, name: 'Ptr. Jonamae L. Bariquatro', role: 'Womens Ministry Leader', initials: 'JL', image: '/leaders/JONAMAE.png', level: 6, order: 1, ministry: 'women' },
      { id: 18, name: 'Sis. Meraflor Etil', role: 'Womens Ministry - Asst', initials: 'ME', image: '/leaders/MERAFLOR.png', level: 6, order: 2, ministry: 'women' },
      
      // Children's Ministry
      { id: 19, name: 'Sis. April Joy Bariquatro', role: 'Childrens Ministry Leader', initials: 'AJ', image: '/leaders/APRIL.png', level: 6, order: 1, ministry: 'children' },
      { id: 20, name: 'Sis. Rio Chen Etil', role: 'Childrens Ministry - Asst', initials: 'RE', image: '/leaders/RIO.png', level: 6, order: 2, ministry: 'children' },
      
      // Youth Ministry
      { id: 21, name: 'Bro. Harry Etil', role: 'Youth Executive / Incharge', initials: 'HE', image: '/leaders/HARRY.png', level: 6, order: 1, ministry: 'youth' },
      { id: 22, name: 'Sis. Cristy D. Bariquatro', role: 'Youth Ministry', initials: 'CB', image: '/leaders/CRISTY.png', level: 6, order: 2, ministry: 'youth' },
      { id: 23, name: 'Sis. Jay-Ann Bariquatro', role: 'Youth Ministry - Asst', initials: 'JA', image: '/leaders/JAY-ANN.png', level: 6, order: 3, ministry: 'youth' },
      
      // Music Team Ministry
      { id: 24, name: 'Bro. Jhonrey B. Bariquatro', role: 'Music Team Leader', initials: 'JB', image: '/leaders/JHONREY.png', level: 6, order: 1, ministry: 'music' },
      { id: 25, name: 'Missionary Arnold Supe', role: 'Music Team', initials: 'AS', image: '/leaders/ARNOLD.png', level: 6, order: 2, ministry: 'music' },
      
      // Evangelism Ministry
      { id: 26, name: 'Ptr. Jerry S. Bariquatro Sr.', role: 'Evangelism Head', initials: 'JS', image: '/leaders/JERRY SR.png', level: 6, order: 1, ministry: 'evangelism' },
      { id: 27, name: 'Ptr. Analiza B. Bariquatro', role: 'Evangelism', initials: 'AB', image: '/leaders/ANALIZA.png', level: 6, order: 2, ministry: 'evangelism' },
      { id: 28, name: 'Missionary Arnold Supe', role: 'Miracle Team Head / Evangelism', initials: 'AS', image: '/leaders/ARNOLD.png', level: 6, order: 3, ministry: 'evangelism' }
    ]
  },
  messages: [] // Contact form messages
};

export const DataProvider = ({ children }) => {
  const [data, setData] = useState(() => {
    const saved = localStorage.getItem('churchData');
    if (saved) {
      const parsedData = JSON.parse(saved);
      // Merge saved data with defaults to ensure new fields exist
      return {
        ...defaultData,
        ...parsedData,
        // Preserve carouselImages if they exist and have data
        carouselImages: parsedData.carouselImages?.length > 0 
          ? parsedData.carouselImages 
          : defaultData.carouselImages,
        churchInfo: { ...defaultData.churchInfo, ...parsedData.churchInfo },
        socialLinks: { ...defaultData.socialLinks, ...parsedData.socialLinks },
        aboutContent: {
          ...defaultData.aboutContent,
          ...parsedData.aboutContent,
          // Keep user's team data if it exists, otherwise use defaults
          team: parsedData.aboutContent?.team?.length > 0 
            ? parsedData.aboutContent.team 
            : defaultData.aboutContent.team
        }
      };
    }
    return defaultData;
  });

  // Load images from IndexedDB on mount
  useEffect(() => {
    const loadImages = async () => {
      const storedImages = await getAllImagesFromDB();
      if (Object.keys(storedImages).length > 0) {
        setData(prev => ({
          ...prev,
          carouselImages: prev.carouselImages.map(img => ({
            ...img,
            image: storedImages[`carousel_${img.id}`] || img.image
          })),
          heroSlides: prev.heroSlides.map(slide => ({
            ...slide,
            image: storedImages[`hero_${slide.id}`] || slide.image
          }))
        }));
      }
    };
    loadImages();
  }, []);

  // Save to localStorage (without large images) and IndexedDB (with images)
  useEffect(() => {
    const saveData = async () => {
      try {
        // Save images to IndexedDB (no size limit issues)
        data.carouselImages.forEach(async (img) => {
          if (img.image && img.image.startsWith('data:')) {
            await saveImageToDB(`carousel_${img.id}`, img.image);
          }
        });
        
        data.heroSlides.forEach(async (slide) => {
          if (slide.image && slide.image.startsWith('data:')) {
            await saveImageToDB(`hero_${slide.id}`, slide.image);
          }
        });

        // Save data to localStorage WITHOUT images (to avoid quota issues)
        const dataWithoutImages = {
          ...data,
          carouselImages: data.carouselImages.map(img => ({
            ...img,
            image: img.image && img.image.startsWith('http') ? img.image : '' // Keep URLs only
          })),
          heroSlides: data.heroSlides.map(slide => ({
            ...slide,
            image: slide.image && slide.image.startsWith('http') ? slide.image : '' // Keep URLs only
          }))
        };
        
        localStorage.setItem('churchData', JSON.stringify(dataWithoutImages));
      } catch (e) {
        console.error('Error saving data:', e);
      }
    };
    
    saveData();
  }, [data]);

  // Update functions
  const updateChurchInfo = (info) => setData(prev => ({ ...prev, churchInfo: { ...prev.churchInfo, ...info } }));
  const updateSocialLinks = (links) => setData(prev => ({ ...prev, socialLinks: { ...prev.socialLinks, ...links } }));
  const updateHeroSlides = (slides) => setData(prev => ({ ...prev, heroSlides: slides }));
  
  const addVideo = (video) => setData(prev => ({ ...prev, videos: [...prev.videos, { ...video, id: Date.now() }] }));
  const updateVideo = (id, video) => setData(prev => ({ ...prev, videos: prev.videos.map(v => v.id === id ? { ...v, ...video } : v) }));
  const deleteVideo = (id) => setData(prev => ({ ...prev, videos: prev.videos.filter(v => v.id !== id) }));
  
  const addEvent = (event) => setData(prev => ({ ...prev, events: [...prev.events, { ...event, id: Date.now() }] }));
  const updateEvent = (id, event) => setData(prev => ({ ...prev, events: prev.events.map(e => e.id === id ? { ...e, ...event } : e) }));
  const deleteEvent = (id) => setData(prev => ({ ...prev, events: prev.events.filter(e => e.id !== id) }));
  
  // Schedule functions
  const addSchedule = (schedule) => setData(prev => ({ ...prev, weeklySchedule: [...prev.weeklySchedule, { ...schedule, id: Date.now() }] }));
  const updateSchedule = (id, schedule) => setData(prev => ({ ...prev, weeklySchedule: prev.weeklySchedule.map(s => s.id === id ? { ...s, ...schedule } : s) }));
  const deleteSchedule = (id) => setData(prev => ({ ...prev, weeklySchedule: prev.weeklySchedule.filter(s => s.id !== id) }));
  
  const addMessage = (message) => setData(prev => ({ ...prev, messages: [...prev.messages, { ...message, id: Date.now(), date: new Date().toISOString(), read: false }] }));
  const markMessageRead = (id) => setData(prev => ({ ...prev, messages: prev.messages.map(m => m.id === id ? { ...m, read: true } : m) }));
  const deleteMessage = (id) => setData(prev => ({ ...prev, messages: prev.messages.filter(m => m.id !== id) }));
  
  const updateAboutContent = (content) => setData(prev => ({ ...prev, aboutContent: { ...prev.aboutContent, ...content } }));
  const updateTeamMember = (id, member) => setData(prev => ({ 
    ...prev, 
    aboutContent: { 
      ...prev.aboutContent, 
      team: prev.aboutContent.team.map(t => t.id === id ? { ...t, ...member } : t) 
    } 
  }));

  const addTeamMember = (member) => setData(prev => ({
    ...prev,
    aboutContent: {
      ...prev.aboutContent,
      team: [...prev.aboutContent.team, { ...member, id: Date.now() }]
    }
  }));

  const deleteTeamMember = (id) => setData(prev => ({
    ...prev,
    aboutContent: {
      ...prev.aboutContent,
      team: prev.aboutContent.team.filter(t => t.id !== id)
    }
  }));

  // Carousel Image functions
  const updateCarouselImages = (images) => setData(prev => ({ ...prev, carouselImages: images }));
  const addCarouselImage = (image) => setData(prev => ({ ...prev, carouselImages: [...prev.carouselImages, { ...image, id: Date.now() }] }));
  const updateCarouselImage = (id, image) => setData(prev => ({ ...prev, carouselImages: prev.carouselImages.map(i => i.id === id ? { ...i, ...image } : i) }));
  const deleteCarouselImage = (id) => setData(prev => ({ ...prev, carouselImages: prev.carouselImages.filter(i => i.id !== id) }));
  
  const resetToDefaults = () => {
    setData(defaultData);
    localStorage.removeItem('churchData');
  };

  return (
    <DataContext.Provider value={{
      data,
      updateChurchInfo,
      updateSocialLinks,
      updateHeroSlides,
      addVideo, updateVideo, deleteVideo,
      addEvent, updateEvent, deleteEvent,
      addSchedule, updateSchedule, deleteSchedule,
      addMessage, markMessageRead, deleteMessage,
      updateAboutContent, updateTeamMember, addTeamMember, deleteTeamMember,
      updateCarouselImages, addCarouselImage, updateCarouselImage, deleteCarouselImage,
      resetToDefaults
    }}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('useData must be used within a DataProvider');
  }
  return context;
};

export default DataContext;
